/*
 * @Description: 
 * @Author: 山淑兰
 * @Date: 2019-12-26 17:32:22
 * @LastEditTime: 2019-12-26 17:32:44
 * @LastEditors: 山淑兰
 */
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?3314f5c7b05d572a8d5337c420f8c3c2";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();
